import Icon from 'bloko/blocks/icon/Icon';
import IconDynamic from 'bloko/blocks/icon/IconDynamic';
import IconLink from 'bloko/blocks/icon/IconLink';
import IconVerticalAlignment from 'bloko/blocks/icon/IconVerticalAlignment';
import Service from 'bloko/blocks/icon/Service';
import Social from 'bloko/blocks/icon/Social';
import IconColor from 'bloko/blocks/icon/colors.d';
import { IconScale, IconAppearance, IconShape, IconKind, IconView } from 'bloko/blocks/icon/variants/icon/types.d';
import { ServiceKind, ServiceView, ServiceScale } from 'bloko/blocks/icon/variants/service/types.d';
import { SocialView, SocialScale, SocialAppearance } from 'bloko/blocks/icon/variants/social/types.d';

export {
    IconColor,
    IconDynamic,
    IconLink,
    IconScale,
    IconAppearance,
    IconShape,
    IconKind,
    IconView,
    IconVerticalAlignment,
    Social,
    SocialView,
    SocialScale,
    SocialAppearance,
    ServiceKind,
    ServiceView,
    ServiceScale,
    Service,
};

export default Icon;
